import { render } from "./DeleteIcon.vue?vue&type=template&id=62ca0eec"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"
script.render = render

export default script